export const googleTagManager = () => (next: Function) => (
    action: Record<string, any>
) => {
    const dataLayer = (window.dataLayer = window.dataLayer || []);

    if (action.meta && action.meta.googleTagManager) {
        const eventData = action.meta.gtmVariables || {};
        const { event, ...rest } = eventData;
        dataLayer.push({
            event: event || action.type,
            ...rest
        });
    }
    return next(action);
};
